/**
 * 安全钱包转账
 */
import { connect } from 'react-redux';
import { Fragment } from 'react'
import { MONEY } from '../../../constants/regulars'
import JSEncrypt from '../../../helpers/jsencrypt';
import './wallet-tranfer.scss'
class WalletTranfer extends React.Component {

  constructor(){
    super();
    this.state = {
      step: 0,
      token: null,
      min_money:null,
      upUser:null
    }
  }
  componentDidMount(){
    this.props.$$USER.getSaftywalletInfo([],(res)=>{
      if(res.status== 35000 || res.status== 35001){
        this.props.$$BASE.openToast(res.message);
        return
      }
      this.setState({
        token:res.data.transfer_token,
        min_money:res.data.min_money
      })
    })
  }

  checkSecPass = () => {
    const __uses = this.props.__USER.toJS();
    const __common = this.props.__COMMON.toJS();
    const { info } =__uses;
    if(!this.refs.password.value){
      return this.props.$$BASE.openToast('请先enter the withdrawal password');
    }
    if(info.twofa == 1 && info.twofa_withdraw_enabled == 1 && !this.refs.googleCode.value){
      return this.props.$$BASE.openToast('请先输入谷歌验证码');
    }
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(__common.settings.public_key);
  
    this.props.$$DASH.checkoutSecPass({securityPass:this.refs.password.value, code: _.get(this.refs, 'googleCode.value')}, {}, ({res}) => {
      if(res.error){
        return this.props.$$BASE.openToast(res.errorMsg);
      }
      this.setState({
        step: 1,
        checkcode: res.message.checkcode
      })
    })
  }
  
  next = () => {
    if(this.refs.money.value <= 0 || !MONEY.test(this.refs.money.value)){
      return this.props.$$BASE.openToast('请输入正确的金额');
    }
    this.setState({
      step: 2,
      money: this.refs.money.value,
    })
    if(this.props.type == 'up'){
      this.setState({
        upUser:this.refs.user.value
      })
    }
  }

  goTransfer = () => {
    const tousername = this.props.user.username;
    const money= this.state.money;
    const transfertype = this.props.type;
    const transfer_token = this.state.token; 
    this.props.$$USER.checkSaftywalletTransferpost([transfertype,tousername,money,transfer_token], (res) => {
      if(res.status != 10000){
        return;
      }{
        this.props.$$BASE.openToast(res.data.message)
        this.props.closeModal();
      }
      
    })
  }
  goUpTransfer = () => {
    const tousername = this.state.upUser;
    const money= this.state.money;
    const transfertype = this.props.type;
    const transfer_token = this.state.token; 
    this.props.$$USER.checkSaftywalletTransferpost([transfertype,tousername,money,transfer_token], (res) => {
      if(res.status != 10000){
        return;
      }{
        this.props.$$BASE.openToast(res.data.message)
        this.props.closeModal();
      }
      
    })
  }

  render() {
    const __uses = this.props.__USER.toJS();
    const __common = this.props.__COMMON.toJS();
    const { info } =__uses;
    
    return (
      <Fragment>
        <div className="report-modal-header">
          {this.props.type == 'up' && '上級转账'}
          {this.props.type == 'down' && '下級转账'}
          {this.props.type == 'selfin' && '转入个人钱包'}
          {this.props.type == 'selfout' && '转出到平台'}  
        </div>
        <div className='transfer-member-box report-modal-content'>
          {
            this.state.step == 0 && 
            <Fragment>
              <div className='step0'>
                <h2>请enter the withdrawal password</h2>
                <input ref='password' type="password"/>
                {
                  (info.twofa == 1 && info.twofa_withdraw_enabled == 1) && 
                  <Fragment>
                    <h2>请输入谷歌验证码</h2>
                    <input ref='googleCode' type="text"/>
                  </Fragment>
                }
              </div>
              <div className="line">&nbsp;</div>
              <div className="actions">
                <button onClick={() => {this.refs.password.value = ''; this.refs.googleCode.value = ''}} className='big'>reset</button>
                <button onClick={this.checkSecPass} className="big submit">确定</button>
              </div>
            </Fragment>
          }
          {
            this.state.step == 1 && 
            <Fragment>
              <div className="step1">
                <div className="item">
                  <span className='label'>用户账号：</span>
                  <span className="value">
                    {this.props.type == 'up'? <input type="text" ref='user' />: this.props.user.username}
                  </span>
                </div>
                <div className="item">
                  <span className='label'>您的余额：</span>
                  <span className="value money">
                    {this.props.type == 'selfin' ? $.formatMoney(this.props.selfinBalance, 4, '￥'): $.formatMoney(this.props.bal, 4, '￥')}
                  </span>
                </div>
                <div className="item">
                  <span className='label'>充值金额：</span>
                  <span className="value">
                    <input type="number" ref='money' defaultValue={this.state.money || ''} />
                  </span>
                </div>
                <div className="item">
                  <span className='label'></span>
                  <span className="value">
                    最低充值金额：<label style={{color: '#fc7c23'}}>{this.state.min_money}</label>
                  </span>
                </div>
              </div>
              <div className="line">&nbsp;</div>
              <div className="actions">
                <button onClick={() => this.refs.money.value = ''} className='big'>reset</button>
                <button onClick={this.next} className="big submit">确定</button>
              </div>
            </Fragment>
          }
          {
            this.state.step == 2 && 
            <Fragment>
              <div className="step1">
                <div className="item">
                  <span className='label'>用户账号：</span>
                  <span className="value">
                  {this.props.type == 'up'? this.state.upUser: this.props.user.username}
                  </span>
                </div>
                <div className="item">
                  <span className='label'>充值金额：</span>
                  <span className="value money">
                    {$.formatMoney(this.state.money, 2, '￥')}
                  </span>
                </div>
                <div className="item">
                  <span className='label'>大写金额：</span>
                  <span className="value money">
                    {$.moneyDX(this.state.money)}
                  </span>
                </div>
              </div>
              <div className="line">&nbsp;</div>
              <div className="actions">
                <button onClick={() => this.setState({step: 1})} className='big'>上一步</button>
                {
                  this.props.type == 'up'? 
                  <button onClick={this.goUpTransfer} className="big submit">确认充值</button>
                  :
                  <button onClick={this.goTransfer} className="big submit">确认充值</button> 
                }
              </div>
            </Fragment>
          }
        </div>
      </Fragment>
    )
  }
}
reactMixin(WalletTranfer.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __USER: state.user,
    __COMMON: state.common
  };
}

function mapDispatchToProps(dispatch) {
  return {
    $$DASH: bindActionCreators(dashAction, dispatch),
    $$BASE: bindActionCreators(baseAction, dispatch),
    $$USER: bindActionCreators(userAction, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WalletTranfer);